import axios from 'axios';
import React, { useEffect, useState } from 'react';
import dateSetting from '../../utils/dateSetting';

import VsPitcherList from './sub/VsPitcherList';
import BatterIndicatorTable from './sub/BatterIndicatorTable';

function BatterIndicatorMain({profile, leagueType}) {
    return (
        <>
        <div className="boxTitle">세부지표</div>
        <BatterIndicatorTable profile={profile} leagueType={leagueType}/>
        </>
    )
}

export default BatterIndicatorMain;